import "./form-util-category.scss";

import { UtilCategoryFormSchema } from "@factory/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = UtilCategoryFormSchema;
export function FormUtilCategory() {
  const { control } = useFormContext<UtilCategoryFormSchema>();
  return (
    <div id="FormUtilCategory" className="util-category">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default FormUtilCategory;
